import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import CreateRoom from './pages/CreateRoom';
import JoinRoom from './pages/JoinRoom';
import Room from './pages/Room';
import MyRoom from './pages/MyRoom';
import Login from './pages/Login';
import Register from './pages/Register';
import Footer from './components/footer';
import Demo from './pages/Demo';
import NotFound from './pages/NotFound';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import { PopupProvider } from './contexts/PopupContext';
import Profile from './pages/Profile';
import Donate from './pages/Donate';

function App() {
  return (
    <PopupProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="container py-4">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/create-room" element={<CreateRoom />} />
              <Route path="/join/:roomId" element={<JoinRoom />} />
              <Route path="/room/:roomId" element={<Room />} />
              <Route path="/my-rooms" element={<MyRoom />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </PopupProvider>
  );
}

export default App; 